<template>
    <main>
        <qrcode-stream @decode="onDecode" ></qrcode-stream>

    </main>
</template>
<script>
    import { QrcodeStream } from 'vue-qrcode-reader'
    export default {
        data:()=>({
            
        }),
        methods:{
            onDecode (content) {
                if(content.includes('gootwork')){
                    location.href=content
                }
                else{
                    console.log(content)
                }
            },

        },
        components:{
            QrcodeStream
        }
    }
</script>

      
        
      
      
      
      
    
     
	 
		
  